import { gql } from "@apollo/client";

export const SEARCH_CANONICAL_ENTITIES = gql`
  query (
    $searchString: String
    $entityType: String
    $first: Int
    $after: String
  ) {
    matchingCanonicalEntities(
      searchString: $searchString
      entityType: $entityType
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          label
          entityType
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
